import { ElevatorsContainer } from '../../containers/advancedFilters/ElevatorsContainer';
import { IFilter } from '../../types/advancedFilters';

export const elevators: IFilter = {
  component: ElevatorsContainer,
};
